


















































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import { AxiosResponse } from "axios";
import FormErrorsMixin from "@/mixins/FormErrors";
import BaseMixin from "@/mixins/BaseMixin";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

import "vue-swatches/dist/vue-swatches.css";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import SuccessButton from "@/components/Common/Buttons/SuccessButton.vue";
import WarningButton from "@/components/Common/Buttons/WarningButton.vue";
import NewCustomerModal from "@/components/Customers/Customer/NewCustomerModal.vue";
import SearchableSelect from "@/components/Common/Select/SearchableSelect.vue";
import Error404 from "@/components/Common/Error404.vue";

import "vue-slider-component/theme/default.css";
import {
  ICustomer,
  IDiscount,
  IInventoryProduct,
  IPaymentType,
  IVat
} from "@/interface";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    InfoButton,
    SuccessButton,
    WarningButton,
    NewCustomerModal,
    DatePicker,
    SearchableSelect,
    Error404
  }
})
export default class BookingInventoryProduct extends Mixins(
  FormErrorsMixin,
  BaseMixin
) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "customer_id",
    "payment_type_id",
    "inventory_product_id",
    "units",
    "starts_at",
    "ends_at",
    "use_manual_price",
    "inventory_products.0.customer_id",
    "inventory_products.0.payment_type_id",
    "inventory_products.0.inventory_product_id",
    "inventory_products.0.units",
    "inventory_products.0.starts_at",
    "inventory_products.0.ends_at",
    "inventory_products.0.use_manual_price"
  ];
  private noDataExist = false;
  private bookingName: string | null = null;
  private showAddCustomerModal = false;
  private dateFormat = "DD.MM.YYYY";
  private timeFormat = "HH:mm";
  private selectedBooking: any = {
    paymentMethod: null,
    remarks: null,
    customer: null,
    from: {
      date: null,
      time: null
    },
    to: {
      date: null,
      time: null
    },
    inventory_product_id: null,
    pricePerUnit: 0,
    discount_id: null,
    amount_net: null,
    amount_gross: null,
    vat: null,
    manual_price_vat_id: null,
    manual_price_amount_gross: null,
    use_manual_price: false,
    units: 0
  };
  private selectedBookingId: string | null = null;
  private paymentTypes: Array<IPaymentType> = [];
  private discounts: Array<IDiscount> = [];
  private customers: Array<ICustomer> = [];
  private products: Array<IInventoryProduct> = [];
  private vats: Array<IVat> = [];
  private debounce: any = null;

  private beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: this) => {
      vm.selectedBookingId = vm.$route.params.booking_id;
      if (
        typeof vm.selectedBookingId !== "undefined" &&
        vm.selectedBookingId !== null
      ) {
        vm.getProductBooking();
        if (vm.$route.query.customer_created === "true") {
          swal("Success!", "The Customer was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        if (vm.$route.query.booking_created === "true") {
          swal("Success!", "The Booking was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
      }
      vm.getProducts();
      vm.getVats();
      vm.getPaymentTypes();
      vm.getDiscounts();
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any) {
    if (
      typeof this.selectedBookingId !== "undefined" &&
      this.selectedBookingId !== null
    ) {
      this.getProductBooking();
    }
    this.getProducts();
    this.getVats();
    this.getPaymentTypes();
    this.getDiscounts();
    next();
  }

  get maxAvailableUnits(): number {
    let inventoryProduct = null;
    if (this.products) {
      inventoryProduct = this.products.find(
        product => product.id === this.selectedBooking.inventory_product_id
      );
    }
    return inventoryProduct !== null &&
      inventoryProduct !== undefined &&
      inventoryProduct.max_available_units
      ? inventoryProduct.max_available_units
      : 0;
  }

  @Watch("selectedBooking.inventory_product_id")
  selectedBooking_inventory_product_id_changed(newState: string): void {
    const inventoryProduct =
      this.products &&
      this.products.find(
        (product: IInventoryProduct) => product.id === parseInt(newState, 10)
      );
    if (newState !== null && inventoryProduct && inventoryProduct.price) {
      this.selectedBooking.units = 1;
      this.selectedBooking.pricePerUnit =
        inventoryProduct.price.form === "gross"
          ? inventoryProduct.price.amount_gross
          : inventoryProduct.price.amount_net;
    }
  }

  private cancelBooking(): void {
    this.$router.push({ name: "BookingInventoryProduct" });
  }

  private createOrUpdateBooking(): void {
    if (this.selectedBookingId == null) {
      this.createBooking();
    } else {
      this.updateBooking();
    }
  }

  private generateSavingData(type = "create"): any {
    if (type === "create") {
      return {
        customer_id: this.selectedBooking.customer.id || null,
        payment_type_id: this.selectedBooking.paymentMethod,
        internal_note: this.selectedBooking.remarks,
        inventory_products: [
          {
            inventory_product_id: this.selectedBooking.inventory_product_id,
            discount_id: this.selectedBooking.discount_id,
            units: this.selectedBooking.units,
            starts_at:
              this.convertDateTime(
                `${this.$moment(this.selectedBooking.from.date).format(
                  this.dateFormat
                )} ${this.$moment(this.selectedBooking.from.time).format(
                  this.timeFormat
                )}`
              ) + ":00",
            ends_at:
              this.convertDateTime(
                `${this.$moment(this.selectedBooking.to.date).format(
                  this.dateFormat
                )} ${this.$moment(this.selectedBooking.to.time).format(
                  this.timeFormat
                )}`
              ) + ":00",
            use_manual_price: this.selectedBooking.use_manual_price,
            manual_price_amount_gross: this.selectedBooking
              .manual_price_amount_gross,
            manual_price_vat_id: this.selectedBooking.manual_price_vat_id
          }
        ]
      };
    } else if (type === "update") {
      return {
        customer_id: this.selectedBooking.customer.id || null,
        payment_type_id: this.selectedBooking.paymentMethod,
        internal_note: this.selectedBooking.remarks,
        inventory_product_id: this.selectedBooking.inventory_product_id,
        discount_id: this.selectedBooking.discount_id,
        units: this.selectedBooking.units,
        starts_at:
          this.convertDateTime(
            `${this.$moment(this.selectedBooking.from.date).format(
              this.dateFormat
            )} ${this.$moment(this.selectedBooking.from.time).format(
              this.timeFormat
            )}`
          ) + ":00",
        ends_at:
          this.convertDateTime(
            `${this.$moment(this.selectedBooking.to.date).format(
              this.dateFormat
            )} ${this.$moment(this.selectedBooking.to.time).format(
              this.timeFormat
            )}`
          ) + ":00",
        use_manual_price: this.selectedBooking.use_manual_price,
        manual_price_amount_gross: this.selectedBooking
          .manual_price_amount_gross,
        manual_price_vat_id: this.selectedBooking.manual_price_vat_id
      };
    }
  }

  private getProductBooking(): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      `bookings/inventory-products/${this.selectedBookingId}`
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        const productBooking = response.data.data;
        const customer = productBooking.booking.customer;

        this.selectedBooking.customer = {
          id: customer.id,
          name: `${customer.last_name} ${customer.first_name}`
        };
        this.bookingName = "Inventory Product Booking";
        this.selectedBooking.paymentMethod =
          productBooking.booking.payment_type.id;
        this.selectedBooking.remarks = productBooking.booking.internal_note;
        this.selectedBooking.inventory_product_id =
          productBooking.inventory_product.id;
        this.selectedBooking.pricePerUnit =
          productBooking.inventory_product_price.form === "gross"
            ? productBooking.inventory_product_price.amount_gross
            : productBooking.inventory_product_price.amount_net;
        this.selectedBooking.discount_id = productBooking.discount?.id;
        this.selectedBooking.from = {
          date: new Date(productBooking.starts_at),
          time: new Date(productBooking.starts_at)
        };
        this.selectedBooking.to = {
          date: new Date(productBooking.ends_at),
          time: new Date(productBooking.ends_at)
        };
        this.selectedBooking.units = productBooking.units;
        this.selectedBooking.amount_net =
          productBooking.booking.total_price.amount_net;
        this.selectedBooking.amount_gross =
          productBooking.booking.total_price.amount_gross;
        this.selectedBooking.vat =
          productBooking.booking.total_price.vat_amount;
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        this.products = [];
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private createBooking(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "bookings/inventory-products"
    );
    const bookingInfo: any = this.generateSavingData("create");

    Api()
      .post(endpoint, bookingInfo)
      .then((response: AxiosResponse) => {
        this.selectedBookingId = response.data.data.id;
        this.$router.push({
          name: "BookingInventoryProductDetails",
          params: { booking_id: `${this.selectedBookingId}` },
          query: { booking_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private updateBooking(): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "bookings/inventory-products/" + this.selectedBookingId
    );
    const bookingInfo: any = this.generateSavingData("update");

    Api()
      .put(endpoint, bookingInfo)
      .then(() => {
        this.getProductBooking();
        swal({
          title: "Success!",
          text: "The booking was updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private onSearchChange(query: string): void {
    if (query.length >= 2) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getCustomers(query);
      }, 600);
    } else {
      this.customers = [];
    }
  }

  private getCustomers(query = ""): Promise<any> {
    const endpoint: string = this.$partnerEndpoint("customers");

    return Api()
      .get(endpoint, {
        params: {
          search: query
        }
      })
      .then((response: AxiosResponse) => {
        this.customers = response.data.data.map(
          ({ id, first_name, last_name }: any) => ({
            id,
            name: `${last_name} ${first_name}`
          })
        );
      })
      .catch((error: any) => {
        console.log(error.response);
      });
  }

  private getProducts(): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("inventory-products");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.products = response.data.data;
      })
      .catch((error: any) => {
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getPaymentTypes(): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("payment-types");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.paymentTypes = response.data.data;
        if (!this.selectedBookingId && this.paymentTypes.length > 0) {
          this.selectedBooking.paymentMethod = this.paymentTypes[0].id;
        }
      })
      .catch((error: any) => {
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getDiscounts(): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("discounts");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.discounts = response.data.data;
      })
      .catch((error: any) => {
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getVats(): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("vats");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.vats = response.data.data;
      })
      .catch((error: any) => {
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private openAddCustomerModal(): void {
    this.showAddCustomerModal = true;
  }

  private closeAddCustomerModal(): void {
    this.showAddCustomerModal = false;
  }

  private onSelectCustomer(customer: ICustomer): void {
    this.showAddCustomerModal = false;
    this.selectedBooking.customer = {
      id: customer.id,
      name: `${customer.last_name} ${customer.first_name}`
    };
    this.customers = [this.selectedBooking.customer];
  }
}
